var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RadarChart',{attrs:{"labels":_vm.labels,"display-legend":_vm.displayLegend,"styles":_vm.styles,"datasets":_vm.chartData,"padding":_vm.padding,"device-pixel-ratio":_vm.devicePixelRatio}})}
var staticRenderFns = []

export { render, staticRenderFns }